import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import Config from "../../Config";
import { useDispatch, useSelector } from "react-redux";

// import {
//   gTypeOfGame
// } from "../../Config";

import { CancelBtn } from "../Styles/InputStyles";

const ViewModel = ({ setOpenViewModel, selectedItem, gTypeOfGame }) => {
  const user = useSelector((state) => state.UserReducer.user);

  const getStatus = (selectedItem) => {
    if (selectedItem.status == 0) {
      return <>{"Not Submitted"}</>;
    } else if (selectedItem.status == 1) {
      return <>{"Pending Docs"}</>;
    } else if (selectedItem.status == 2) {
      return <>{"Pending Payment"}</>;
    } else if (selectedItem.status == 3) {
      return <>Inprogress</>;
    } else if (selectedItem.status == 4) {
      return <>Approved by the Assistant Registrar</>;
    } else if (selectedItem.status == 5) {
      return <>Completed</>;
    } else if (selectedItem.status == 6) {
      return <>{"Certificate Issued"}</>;
    } else if (selectedItem.status == 7) {
      return <>{"Notice Issued"}</>;
    } else if (selectedItem.status == 8) {
      return <>{"Cancelled"}</>;
    } else {
      return <>Rejected</>;
    }
  };

  const parseTypeofGames = (values) => {
    if (values == null) return "NA";
    var typeOfGames = "";
    selectedItem?.games.split(",").map((ln, i) => {
      const selectedItem = gTypeOfGame.find((item) => item.id == ln);
      if (typeOfGames == "") typeOfGames = selectedItem.name;
      else typeOfGames = typeOfGames + "," + selectedItem.name;
    });
    return typeOfGames;
  };
  return (
    <Model width={"w-11/12 max-w-2xl"} setOpenModel={setOpenViewModel}>
      <Wrapper>
        <Title>View Details</Title>
        {user?.userType == 5 && (
          <>
            <SingleItem
              name={"Status"}
              value={getStatus(selectedItem) || "NA"}
            />
          </>
        )}
        <SingleItem name={"Assoc Name"} value={selectedItem?.assocName} />
        <SingleItem name={"Email"} value={selectedItem?.email} />
        {/* <SingleItem name={"Mobile"} value={selectedItem?.email} /> */}
        <SingleItem
          name={"Type Of Game"}
          value={parseTypeofGames(selectedItem?.games) || "NA"}
        />

        <SingleItem
          name={"Type Of Registration"}
          value={selectedItem?.typeOfRegLabel || "NA"}
        />
        <SingleItem
          name={"Type Of Assocation"}
          value={selectedItem?.typeOfAssocLabel || "NA"}
        />
        <SingleItem name={"Region"} value={selectedItem?.regionLabel || "NA"} />
        <SingleItem
          name={"District"}
          value={selectedItem?.districtLabel || "NA"}
        />
        <SingleItem
          name={"Council"}
          value={selectedItem?.councilLabel || "NA"}
        />
        <SingleItem
          name={"Office Address"}
          value={selectedItem?.officeAddr || "NA"}
        />
        <SingleItem
          name={"Postal Address"}
          value={selectedItem?.postalAddr || "NA"}
        />
        <SingleItem
          name={"Objective"}
          value={selectedItem?.objective || "NA"}
        />
        <SingleItem
          name={"No Of Members"}
          value={selectedItem?.noOfMembers || "NA"}
        />
        {/* <SingleItem name={"Formation Date"} value={selectedItem?.formationDate || "NA"} /> */}
        {/* <SingleItem name={"Intend To Purpose"} value={selectedItem?.purpose337} /> */}
        <SingleItem
          name={"Office Bear Title"}
          value={selectedItem?.officeBearTitle || "NA"}
        />
        <SingleItem
          name={"Holder Names"}
          value={selectedItem?.holderNames || "NA"}
        />
        <SingleItem
          name={"Holding Terms"}
          value={selectedItem?.holdingTerms || "NA"}
        />
        <SingleItem
          name={"Chairman Name"}
          value={selectedItem?.chairmanName || "NA"}
        />
        <SingleItem
          name={"Secretary Name"}
          value={selectedItem?.secretaryName || "NA"}
        />
        {/* <SingleItem name={"Remarks"} value={selectedItem?.remarks || "NA"} /> */}
        {/* <SingleItem
          name={"Remarks"}
          value={selectedItem?.remarks || "NA"}
          isScrollable={true}
        />
        <SingleItem
          name={"Reg Remarks"}
          value={selectedItem?.regRemarks || "NA"}
          isScrollable={true}
        /> */}
        <SingleItem
          name={"Created Date"}
          value={moment(selectedItem?.created_at).format("DD-MM-YYYY hh:mm A")}
        />
        {/* <SingleItem name={"Updated Date"} value={moment(selectedItem?.update_at).format("DD-MM-YYYY hh:mm A")} /> */}

        {selectedItem.constitution && (
          <SingleItem
            name={"Constitution Doc"}
            value={
              <LinkValue>
                <a
                  href={Config.docUrl + selectedItem.constitution}
                  target="_blank"
                >
                  Constitution Doc
                </a>
              </LinkValue>
            }
          />
        )}
        {selectedItem.mom && (
          <SingleItem
            name={"Mintue Of Meetings"}
            value={
              <LinkValue>
                <a href={Config.docUrl + selectedItem.mom} target="_blank">
                  Mintue Of Meetings
                </a>
              </LinkValue>
            }
          />
        )}
        {selectedItem.financials && (
          <SingleItem
            name={"Financial Doc"}
            value={
              <LinkValue>
                <a
                  href={Config.docUrl + selectedItem.financials}
                  target="_blank"
                >
                  Financials
                </a>
              </LinkValue>
            }
          />
        )}
        {selectedItem.principals && (
          <SingleItem
            name={"Principals Doc"}
            value={
              <LinkValue>
                <a
                  href={Config.docUrl + selectedItem.principals}
                  target="_blank"
                >
                  Principals Doc
                </a>
              </LinkValue>
            }
          />
        )}
        {selectedItem.members && (
          <SingleItem
            name={"Member's Info"}
            value={
              <LinkValue>
                <a href={Config.docUrl + selectedItem.members} target="_blank">
                  Member's Info
                </a>
              </LinkValue>
            }
          />
        )}
        {selectedItem.coi && (
          <SingleItem
            name={"Certificate of Incorporation"}
            value={
              <LinkValue>
                <a href={Config.docUrl + selectedItem.coi} target="_blank">
                  COI
                </a>
              </LinkValue>
            }
          />
        )}
        {selectedItem.cor && (
          <SingleItem
            name={"Certificate of Registeration Barella"}
            value={
              <LinkValue>
                <a href={Config.docUrl + selectedItem.cor} target="_blank">
                  COR
                </a>
              </LinkValue>
            }
          />
        )}
        {selectedItem.TIN && (
          <SingleItem
            name={"TIN No. Certificate"}
            value={
              <LinkValue>
                <a href={Config.docUrl + selectedItem.TIN} target="_blank">
                  TIN
                </a>
              </LinkValue>
            }
          />
        )}
        {selectedItem.certificateName && (
          <SingleItem
            name={"Certificate"}
            value={
              <LinkValue>
                <a
                  href={
                    Config.certificateUrl +
                    selectedItem.id +
                    "/" +
                    selectedItem.certificateName
                  }
                  target="_blank"
                >
                  Download Certificate
                </a>
              </LinkValue>
            }
          />
        )}

        {selectedItem.notice && (
          <SingleItem
            name={"Notice"}
            value={
              <LinkValue>
                <a
                  href={
                    Config.certificateUrl +
                    selectedItem.id +
                    "/" +
                    selectedItem.notice
                  }
                  target="_blank"
                >
                  Download Notice
                </a>
              </LinkValue>
            }
          />
        )}
        {selectedItem.cancellationDocs && (
          <SingleItem
            name={"Cancellation Docs"}
            value={
              <LinkValue>
                <a
                  href={
                    Config.certificateUrl +
                    selectedItem.id +
                    "/" +
                    selectedItem.cancellationDocs
                  }
                  target="_blank"
                >
                  Download Cancellation Docs
                </a>
              </LinkValue>
            }
          />
        )}
        {selectedItem.chairmanSignature && (
          <SingleItem
            name={"Chairman National Id"}
            value={
              // <LinkValue>
              // <a  href= {(Config.docUrl + selectedItem.chairmanSignature )} target="_blank">Chairman Signature</a>
              // </LinkValue>
              <CertificateImage
                src={Config.docUrl + selectedItem.chairmanSignature}
              />
            }
          />
        )}
        {selectedItem.secretarySignature && (
          <SingleItem
            name={"Secretary National Id"}
            value={
              // <LinkValue>
              // <a  href= {(Config.docUrl + selectedItem.secretarySignature )} target="_blank">Secretary Signature</a>
              // </LinkValue>} />
              <CertificateImage
                src={Config.docUrl + selectedItem.secretarySignature}
              />
            }
          />
        )}
        {/* <SingleItem
          name={"Chairman NId"}
          value={selectedItem?.chairmanSignature || "NA"}
        />
        <SingleItem
          name={"Secretary NId"}
          value={selectedItem?.secretarySignature || "NA"}
        /> */}
      </Wrapper>
      <BtnWrapper>
        <CancelBtn onClick={() => setOpenViewModel(false)}>Close</CancelBtn>
      </BtnWrapper>
    </Model>
  );
};

// const SingleItem = ({ name, value, link, url }) => (
//   <div className="flex items-center py-2 border-b border-gray-100 ">
//     <Name>{name}</Name> <p className="w-10">:</p>
//     {link && (
//       <LinkValue href={url} target="_blank" title="Click to open">
//         {value}
//       </LinkValue>
//     )}
//     {!link && <Value>{value}</Value>}
//   </div>
// );

const SingleItem = ({ name, value, link, url, isScrollable }) => (
  <div
    className={`flex items-center py-2 border-b border-gray-100 ${
      isScrollable ? "scrollable" : ""
    }`}
  >
    <Name>{name}</Name> <p className="w-10">:</p>
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link &&
      (isScrollable ? (
        <ScrollableValue>{value}</ScrollableValue>
      ) : (
        <Value>{value}</Value>
      ))}
  </div>
);

const ScrollableValue = tw.p`
  text-sm text-gray-800 font-medium max-w-xs
  overflow-y-auto  
  max-h-20     
`;

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl mb-6 text-gray-700 font-medium text-left`;
const Name = tw.p`text-sm text-gray-500  w-40`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;
const CertificateImage = tw.img`
w-24 h-12 md:w-24 md:h-12 overflow-hidden bg-gray-100
`;
const BtnWrapper = tw.div` w-full flex items-center justify-end space-x-10 mt-8`;

export default ViewModel;
